import _ from 'lodash';
import { Form } from '../application/form';
import { AttributeDefinition } from '../attributes/attributeDefinition';
import { Attribute } from 'src/app/shared/models/attributes/attribute';
import { SurveyStatus } from './surveyStatus';

export class SurveyForm {
  public form: Form;
  public questions: AttributeDefinition[];
  public status: SurveyStatus;
  public teamName: string;
  public publicTeamName: string;
  public personAndSeatAttributes: Attribute[] = [];

  get title(): string {
    return this.form?.title;
  }

  get displayTitle(): string {
    return this.form?.displayTitle;
  }

  get hasIntroduction(): boolean {
    return !_.isEmpty(this.introduction);
  }

  get introduction(): string {
    return this.form?.introduction;
  }

  get hasConfirmation(): boolean {
    return !_.isEmpty(this.confirmation);
  }

  get hasCompleted(): boolean {
    return this.status === SurveyStatus.Complete;
  }

  get confirmation(): string {
    return this.form?.confirmation;
  }

  get hasConfirmationTitle(): boolean {
    return !_.isEmpty(this.confirmationTitle);
  }

  get confirmationTitle(): string {
    return this.form?.confirmationTitle;
  }

  public static parse(data: any): SurveyForm {
    if (!data) return null;
    let surveyForm = new SurveyForm();
    Object.assign(surveyForm, data);
    surveyForm.form = Form.parse(data.form);
    surveyForm.questions = _.map(data.questions, (question) => {
      let q = AttributeDefinition.parse(question);
      q.conditions = question.conditions;
      return q;
    });
    surveyForm.personAndSeatAttributes = data.personAndSeatAttributes
      ? data.personAndSeatAttributes.map((att) => Attribute.parse(att))
      : [];
    return surveyForm;
  }
}
